import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { commonMessages } from 'ne01-common/src/i18n';

Vue.use(VueI18n);

const messages = {
  'de': {
    ... commonMessages.de
  },
  'fr': {
    ... commonMessages.fr
  }
};

const i18n = new VueI18n({
  locale: 'de',
  messages,
});

export default i18n;